<template>
  <div>
    <template v-if="files.length > 0">
      <v-show-file :files="files" :url-action-remove="urlActionRemove"></v-show-file>
    </template>

    <div>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        data-toggle="modal"
        data-target="#file_upload"
      >
        <icon name="upload" size="fa-1x"></icon>
        {{ $t('file_upload') }}
      </button>
      {{ `${$t('auantity_added')}: ${Object.keys(temsDescriptions).length}` }}
    </div>

    <div
      class="modal"
      id="file_upload"
      tabindex="-1"
      role="dialog"
      aria-labelledby="file_upload"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">
              {{ $t('file_upload') }}
              <template v-if="loadingJimp">
                ...{{ $t('loading') }}
              </template>
            </h4>
          </div>
          <div class="modal-body">
            <div
              v-if="Object.keys(temsDescriptions).length > 0"
              class="pt-10 pb-10"
            >
              <div v-for="(description, index) in temsDescriptions" :key="`${randomString(10)}-${description.id}`">
                <div v-if="['jpeg', 'jpg', 'png'].indexOf(description.type, 0) !== -1">
                  <img :src="description.src" width="50" height="50">
                  <label for="description">{{ `(${index + 1}) ${description.name}` }}</label>
                </div>
                <div v-else>
                  <label for="description">{{ `(${index + 1}) ${description.name}` }}</label>
                </div>
                <vue-weirdotab
                  :data="description"
                  :index="index"
                  placeholder="Descripción corta del archivo"
                ></vue-weirdotab>
              </div>
            </div>
            <input
              accept="application/pdf,mage/png,image/jpeg,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              @change="handleFileUpload"
              type="file"
              class="form-control"
              multiple="multiple"
            >
          </div>
          <div class="modal-footer">
            <div class="btn-group btn-group-toggle">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                data-dismiss="modal"
              >Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'v-jimp',
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      },
    },
    urlActionRemove: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      increments: 0,
      temsDescriptions: [],
    }
  },
  computed: {
    ...mapGetters({
      loadingJimp: 'loadingJimp',
      filesJimp: 'filesJimp',
      errorJimp: 'errorJimp',
    }),
  },
  watch: {
    temsDescriptions: {
      deep: true,
      handler(temsDescriptions) {
        this.$store.dispatch('loadFullFile', temsDescriptions)
      },
    },
    filesJimp: function (data) {
      if (this.errorJimp === null && data && this.isArray(data) && data.length > 0 && !this.loadingJimp) {
        const selt = this
        data.forEach((dataFile, index) => {
          selt.increments = selt.increments + 1
          const file = dataFile.file
          const key = this.assignIndexIfInstantDescription(selt.increments, dataFile.attributes, index)
          const value = this.assignIfInstantDescription(dataFile.attributes)
          const fullType = file.type
          const type = fullType.split('/')
          const reader = new FileReader()
          reader.onload = function(e) {
            selt.temsDescriptions.push({
              id: key,
              value: value,
              tag: 'input',
              max: 191,
              min: 2,
              visible: true,
              editable: true,
              lugar: 'jimp',
              type: type[1],
              src: e.target.result,
              name: `${file.name}.${type[1]}`,
            })
          }
          reader.readAsDataURL(file)
        })
      }
    },
  },
  methods: {
    handleFileUpload(e) {
      const { files } = e.target
      this.$store.dispatch('alterWithJimp', { files, attributes: null })
    },
  },
  destroyed: function () {
    this.increments = 0
    this.temsDescriptions = []
    this.$store.commit('GET_JIMP_RECORDS_START')
    this.$store.commit('GET_JIMP_START')
  },
}
</script>
